import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'app-text-area',
  template: `
    <textarea [rows]="textareaRow" [cols]="textareaColumn" [formControl]="formControl" [formlyAttributes]="field" pInputTextarea [autoResize]="autoResize"></textarea>
  `,
  styleUrls: ['./text-area.component.less']
})
export class TextAreaComponent extends FieldType {
  formControl!: FormControl;
  constructor() {
    super();
  }

  ngOnInit(): void {
  }

  public get textareaRow(): number { return this.to.textareaRow !== undefined ? this.to.textareaRow : 5; }
  public get textareaColumn(): number { return this.to.textareaColumn !== undefined ? this.to.textareaColumn : 30; }
  public get autoResize(): boolean { return this.to.autoResize !== undefined ? this.to.autoResize : false; }
}
